import { render, staticRenderFns } from "./editor.vue?vue&type=template&id=9c766ef4&scoped=true"
import script from "./editor.vue?vue&type=script&lang=js"
export * from "./editor.vue?vue&type=script&lang=js"
import style0 from "./editor.vue?vue&type=style&index=0&id=9c766ef4&prod&lang=scss&scoped=true"
import style1 from "./editor.vue?vue&type=style&index=1&id=9c766ef4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c766ef4",
  null
  
)

export default component.exports